import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationModalContentContainer = (props: Props) => {
  const { children, size = 'md' } = props;

  const { match } = useResponsive();

  const sizeStyles =
    size === 'lg'
      ? styles.contentContainerLG
      : match([styles.contentContainerXS, styles.contentContainerMD]);

  return <View style={[styles.contentContainer, sizeStyles]}>{children}</View>;
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  contentContainer: {
    gap: theme.spacing['4'],
  },
  contentContainerXS: {
    paddingVertical: theme.spacing['6'],
    paddingHorizontal: theme.spacing['4'],
  },
  contentContainerMD: {
    paddingTop: theme.spacing['6'],
    paddingHorizontal: theme.spacing['6'],
    paddingBottom: theme.spacing['10'],
  },
  contentContainerLG: {
    paddingHorizontal: theme.spacing['6'],
    paddingVertical: theme.spacing['10'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  size?: 'md' | 'lg';
}>;
